import { useService } from "@policoders/di";
import { BreadcrumbService, TColumn, TTableActions, TTableLineActions } from "@policoders/ds";
import { useEffect, useState } from "react";

import formatHelper from "../../../../../core/helpers/formatHelper";
import ProductForm from "./product.form";
import { Product } from "./product.model";
import { ProductStore } from "./product.store";

export const useProduct = () => {
  const store = useService<ProductStore>("ProductStore");
  const [lines, setLines] = useState<Product[]>([]);

  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([
      { label: "Chef's Assistant", value: "/chefs-assistant" },
      { label: "Estoque", value: "" },
      { label: "Produtos", value: "/chefs-assistant/stock/products" },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    store.loadList();
    var subscriber = store.state$.subscribe(state => {
      state.products &&
        setLines(
          state.products.map(product => ({
            ...product,
            lastPurchasePriceFormated: formatHelper.currency(product.lastPurchasePrice),
            unitFormated: `${formatHelper.measure(product.unit)} ${product.measureUnit}`,
          })),
        );
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [store]);

  const handleSave = async () => {
    store.save();
  };

  const handleNew = () => {
    const model = new Product();
    store.updateCurrent(model);
    store.ui.modal
      .config({
        title: "novo produto",
        size: "large",
        buttonOkLabel: "Criar",
        buttonOkAction: handleSave,
        children: () => (
          <ProductForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleEdit = (line: Product) => {
    const model = lines.find(x => x.id === line.id);
    if (!model) return;
    store.ui.modal
      .config({
        title: `editar produto (${line.id.split("-")[0]})`,
        size: "large",
        buttonOkLabel: "Salvar",
        buttonOkAction: handleSave,
        children: () => (
          <ProductForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleDelete = (line: Product) => {
    if (window.confirm("excluir produto?")) store.delete(line.id);
  };

  const tActions: TTableLineActions[] = [{ label: "excluir", onClick: handleDelete }];

  const tColumns: TColumn[] = [
    { field: "productCode", title: "Código", columnClass: "d-none d-md-table-cell" },
    { field: "productName", title: "Produto" },
    { field: "unitFormated", title: "Unidade", columnClass: "d-md-table-cell" },
    {
      field: "lastPurchasePriceFormated",
      title: "Últ. preço",
      columnClass: "d-sm-table-cell text-nowrap",
    },
  ];

  const tHeaderButtons: TTableActions = {
    buttonNew: {
      label: "Novo",
      action: handleNew,
    },
  };

  return {
    lines,
    tActions,
    tColumns,
    tHeaderButtons,
    handleEdit,
  };
};
